import SearchIcon from '@mui/icons-material/Search'
import { Box, InputAdornment, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useSelectSite } from '../api/hooks/useSelectSite'
import { siteActiveLicenses } from '../api/services/apiService'
import { setProductLicenses } from '../store/authSlice'
import { useAppDispatch } from '../store/store.hooks'
import { Site } from '../types/site.types'
import { useUserDetails, useUserSitesByOrg } from '../user/hooks/user.hooks'
import SiteCard from './components/SiteCard'

const OrganizationHub = () => {

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const sites = useUserSitesByOrg()
  const { selectSite } = useSelectSite()
  const userDetails = useUserDetails()
  const [search, setSearch] = useState('')

  const filteredSites = userDetails?.isAdmin && search
    ? sites.filter((org) =>
        org.organizationName.toLowerCase().includes(search.toLowerCase()) ||
        org.sites.some((site) => site.name.toLowerCase().includes(search.toLowerCase()))
      )
    : sites

  const handleSiteClick = async (site: Site) => {
    await selectSite(site)
    const licensesResponse = await siteActiveLicenses.list(site.id)
    dispatch(setProductLicenses(licensesResponse))
    navigate('/')
  }

    const ICON_SIZE = 38

  return (
    <Box sx={{ p: 6, display: 'flex', flexDirection: 'column', gap: 4 }}>
      {userDetails?.isAdmin && (
        <TextField
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Rechercher une organisation..."
          size="small"
          sx={{ maxWidth: 320 }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            },
          }}
        />
      )}
      {[...filteredSites].sort((a, b) => a.organizationName.localeCompare(b.organizationName)).map((org) => (
        <Box 
        id="organization-section"
        key={org.organizationId}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <Box
              sx={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                borderRadius: '50%',
                bgcolor: 'action.hover',
                border: '0.5px solid',
                borderColor: 'divider',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  width: ICON_SIZE,
                  height: ICON_SIZE,
                  borderRadius: '50%',
                  bgcolor: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography sx={{ fontSize: 18, fontWeight: 400, color: 'primary.contrastText' }}>
                  {org.organizationName
                    .split(' ')
                    .slice(0, 2)
                    .map((w) => w[0])
                    .join('')
                    .toUpperCase()}
                </Typography>
              </Box>
            </Box>
            <Typography  sx={{ fontSize: 20, fontWeight: 500 }}>{org.organizationName}</Typography>
            <Typography sx={{ fontSize: 12, color: 'text.disabled' }}>
              {org.sites.length} site{org.sites.length > 1 ? 's' : ''}
            </Typography>
          </Box>

          {/* Cartes des sites */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 200px))', 
              gridAutoRows: '200px',
              gap: 3,
              mb: 3,
            }}
          >
            {org.sites.map((site) => (
              <SiteCard key={site.id} name={site.name} onClick={() => handleSiteClick(site)} />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default OrganizationHub
